import { render, staticRenderFns } from "./TranslationLoading.vue?vue&type=template&id=99f3291e"
import script from "./TranslationLoading.vue?vue&type=script&lang=js"
export * from "./TranslationLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports